import React from "react";
import Button from "../../ui/Button";

import { ChevronLeft, ChevronRight } from "lucide-react";
import "./pagination.css";

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  siblingCount = 1,
}) => {
  const range = (start, end) => {
    let arr = [];
    for (let i = start; i <= end; i++) arr.push(i);
    return arr;
  };

  const getPaginationRange = () => {
    const totalPageNumbers = siblingCount * 2 + 5;

    if (totalPages <= totalPageNumbers) {
      return range(1, totalPages);
    }

    const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
    const rightSiblingIndex = Math.min(currentPage + siblingCount, totalPages);

    const showLeftDots = leftSiblingIndex > 2;
    const showRightDots = rightSiblingIndex < totalPages - 1;

    if (!showLeftDots && showRightDots) {
      return [...range(1, 3 + 2 * siblingCount), "...", totalPages];
    }

    if (showLeftDots && !showRightDots) {
      return [1, "...", ...range(totalPages - (3 + 2 * siblingCount) + 1, totalPages)];
    }

    return [
      1,
      "...",
      ...range(leftSiblingIndex, rightSiblingIndex),
      "...",
      totalPages,
    ];
  };

  const paginationRange = getPaginationRange();

  return (
    <div className="pagination">
      {/* Prev */}
      <Button
        variant="secondary"
        size="sm"
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
      >
        <ChevronLeft size={16} />
      </Button>

      {/* Pages */}
      {paginationRange.map((page, index) =>
        page === "..." ? (
          <span key={`${page}-${index}`} className="dots">...</span>
        ) : (
          <Button
            key={`${page}-${index}`}
            size="sm"
            variant={page === currentPage ? "primary" : "ghost"}
            className={page === currentPage ? "active" : ""}
            onClick={() => onPageChange(page)}
          >
            {page}
          </Button>
        )
      )}

      {/* Next */}
      <Button
        variant="secondary"
        size="sm"
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
      >
        <ChevronRight size={16} />
      </Button>
    </div>
  );
};

export default Pagination;